
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class EditEngineSpeedDialog extends Vue {
  @Prop({ type: Number }) speed = 0;
  @Prop() show = false;
  speed_rpm = 0;
  editFormValid = false;
  created() {
    this.speed_rpm = this.speed;
  }
  confirmUpdate(val: any) {
    this.$emit('update:show', false);
    this.$emit('update:speed', val);
  }
  close() {
    this.$emit('update:show', false);
  }
}
